<template>
  <div>
    <span class="saveby-icon">
      <i :class="iconClass"></i>
    </span>
    <span>{{row['saveBy']}}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number, Boolean],
    types: {
      type: Object,
      required: true
    },
    row: Object,
    column: Object,
    formated: [String, Number, Boolean]
  },
  computed: {
    type() {
      return this.row["saveby_type"];
    },
    currentIcon() {
      return this.types[this.type] || "tg-icon-other-card";
    },
    iconClass() {
      return ["tg-icon", this.currentIcon];
    }
  }
};
</script>